/**
 * RoleGuard — restreint le rendu d'un sous-arbre React au porteur d'un rôle minimum.
 *
 * Hiérarchie : viewer < analyst < admin < super_admin.
 *
 * <RoleGuard role="super_admin" fallback={<Navigate to="/" />}>
 *   <SuperAdminOnlyPanel />
 * </RoleGuard>
 */
import React from "react";
import { useAuth } from "@/context/AuthContext";

const HIERARCHY = ["viewer", "analyst", "admin", "super_admin"];

function rank(r) {
  if (!r) return -1;
  const i = HIERARCHY.indexOf(r);
  return i === -1 ? -1 : i;
}

export function hasRole(user, required) {
  if (!user) return false;
  // Cas spécial : admin@vitae-publica.org est super_admin par défaut côté UI
  // (le backend fait la même promotion au boot)
  let role = user.role;
  if ((user.email || "").toLowerCase() === "admin@vitae-publica.org" && !role) {
    role = "super_admin";
  }
  return rank(role) >= rank(required);
}

export default function RoleGuard({ role, fallback = null, children }) {
  const { user } = useAuth();
  if (!hasRole(user, role)) return fallback;
  return <>{children}</>;
}
